import { fromJS } from 'immutable';
import { SET_MANAGER_PENDING_CLAIMS } from 'containers/ManagerPendingClaims/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { SET_SEARCH } from 'containers/ValidatedClaimsPage/constants';
import { get } from 'lodash';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const managerPendingClaimsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_MANAGER_PENDING_CLAIMS:
      if (action.isManagerSearching) {
        return state
          .set('claims', fromJS(action.response))
          .set('countClaims', fromJS(action.response.length));
      }
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case SET_SEARCH:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default managerPendingClaimsReducer;
